import { IMachineDefault } from '_core/types';
export const IMachine: IMachineDefault = {
  IDLE: 'IDLE',
  START: 'START',
  FINISH: 'FINISH',
  PREPARE_DATA: 'PREPARE_DATA',
};
